import { useLocale } from 'next-intl'
import { IMultiLang } from '../_types'
import { getLocale } from 'next-intl/server'

export const useCustomLocale = () => {
  const locale = useLocale()
  return (['en', 'ru'].includes(locale) ? locale : 'uz') as keyof IMultiLang
}

export const getCustomLocale = async (lng?: string) => {
  let locale
  if (lng) {
    locale = lng
  } else {
    locale = await getLocale()
  }
  return (['en', 'ru'].includes(locale) ? locale : 'uz') as keyof IMultiLang
}
